import { CallModel } from '@/types';
import BaseService from '@/services/api/BaseService';
import { AxiosRequestConfig } from 'axios';

class CallService<T> extends BaseService<CallModel> {
    getCsvReport<ResponseT = T[]>(config?: AxiosRequestConfig) {
        return this.http.get<ResponseT>(`${this.route}/report/csv`, config);
    }
}

export default new CallService('calls');
